import { NumberCoercible } from '../utils/NumberCoercible';
import { NumberFormat } from './NumberFormat';

export type GetPercentPartsReturnType = Intl.NumberFormatPart[];

// Default percent style - no decimal values.
const NUMBER_FORMAT_OPTIONS = {
  style: 'percent',
} as const;

export const buildPercentFormat = (locale?: string): Intl.NumberFormat => NumberFormat(locale, NUMBER_FORMAT_OPTIONS);

/**
 * A default percent formatter.
 */
export const percentFormatter = (v: NumberCoercible, locale?: string): string =>
  buildPercentFormat(locale).format(v.valueOf());
